<template>
    <basic-card-component-layout :renderData="renderData">

        <component
            :is="renderData.cardType"
            slot-scope="{item}"
            :item="item"
            @card-clicked="handleCardClick"
        >

        </component>
    </basic-card-component-layout>
</template>

<script>

    import PreviewComponent from "./PreviewComponent";
    import BasicCardComponentLayout from "../../author/pagesbuilder/templates/BasicCardComponentLayout";
    import CommunityPostsCard1 from "../../author/pagesbuilder/templates/cards/CommunityPostsCard1";
    import CommunityPostsCard2 from "../../author/pagesbuilder/templates/cards/CommunityPostsCard2";
    import CommunityPostsCard3 from "../../author/pagesbuilder/templates/cards/CommunityPostsCard3";
    import CommunityPostsCard4 from "../../author/pagesbuilder/templates/cards/CommunityPostsCard4";
    import CommunityPostsCard5 from "../../author/pagesbuilder/templates/cards/CommunityPostsCard5";
    import CommunityPostsCard6 from "../../author/pagesbuilder/templates/cards/CommunityPostsCard6";
    import CommunityPostCardsComponent from "../../components/pagesbuilder/dynamic-components/CommunityPostCardsComponent";
    import RowsMixin from "../../author/pagesbuilder/mixins/RowsMixin";
    
    export default {
        name: "PreviewCommunityPostCardsComponent",
        mixins: [
            PreviewComponent,
            CommunityPostCardsComponent
        ],
        computed: {
            hasPostsToShow () {
                return this.renderData?.data && Object.values(this.renderData.data).length > 0;
            },
        },
        methods: {
            handleCardClick () {
                this.redirectToSocial();
            },
            redirectToSocial () {
                window.location.href = "/social";
            },
            loadMoreClicked () {
                this.setRows({value: this.myData.rows + 1});
            },
            seeAllClicked () {
                this.redirectToSocial();
            },
            toggleMySectionVisibility (display) {
                const mySection = this.hasContext('section')[0];
                if (mySection) {
                    const mySectionState = this.findNodeState(mySection.id);
                    mySectionState.myNode.style.display = display ? 'block' : null;
                }
            }
        },
        watch: {
            hasPostsToShow: {
                handler : function (newVal) {
                    this.toggleMySectionVisibility(newVal);
                },
            }
        },
        components: {
            BasicCardComponentLayout,
            CommunityPostsCard1,
            CommunityPostsCard2,
            CommunityPostsCard3,
            CommunityPostsCard4,
            CommunityPostsCard5,
            CommunityPostsCard6
        }
    }
</script>
